import './css/main_style.css';
import './css/index.css';
import React, { useState } from "react";
import {BrowserRouter as Router,Switch,Route} from "react-router-dom";
import { AuthContext } from "./context/auth";
import PrivateRoute from './PrivateRoute';
import Home from "./pages/home";
import Apply from "./pages/apply"
import SetupTable from "./pages/setupTables";
import MemberApp from "./pages/MemberApp";
import AppDone from "./pages/AppDone";
import DirectFail from "./pages/DirectFail";
import IncomeFail from "./pages/IncomeFail";
import Member from "./login/Login";
import Login from "./login/Login";
import Logout from './login/logout';
import EmpOut from './manages/logout';
import Payday from "./pages/paydayloan";
import Paybank from "./pages/paybank";
import Reloan from "./pages/reloan";
import Setting from "./pages/Management";
import Manages from "./manages/Login";
import Application from "./manages/application";
import Management from "./manages/Management";
import Report from "./manages/report";
import Search from "./manages/search";
import CashAdvance from "./pages/cashAdvance";
import Onlinepaydayloans from "./pages/onlinepaydayloan";
import Badcreditloans from "./pages/badcredit";
import Financials from "./pages/financials";
import Tool from "./pages/tools"
import Contact from "./pages/contact";
import Privacypolicy from "./pages/privacy";
import Questions from "./pages/questions";
import Career from "./pages/careers"
import MSetting from "./manages/settings";

function App() {
	const [authTokens, setAuthTokens] = useState();    
	const setTokens = (data) => {			
		if(!data) {
			setAuthTokens(data);
		} else {						
			localStorage.setItem("tokens", JSON.stringify(data[0]));										
			setAuthTokens(data);
		}
	}	
	return (	
		<AuthContext.Provider value={{ authTokens, setAuthTokens: setTokens }}>	
			<Router>		
				<div>				        	
					<Switch>				
						<Route exact path="/" component={Home} />	
						<Route exact path="/Apply" component={Apply} />	
						<Route exact path="/SetupTable" component={SetupTable} />	
						<Route exact path="/MemberApp" component={MemberApp} />	
						<Route exact path="/AppDone" component={AppDone} />	
						<Route exact path="/DirectFail" component={DirectFail} />	
						<Route exact path="/IncomeFail" component={IncomeFail} />
						<Route exact path="/Member" component={Member} />
						<Route exact path="/Manages" component={Manages} />	
						<Route exact path="/Login" component={Login} />
						<Route exact path="/CashAdvance" component={CashAdvance} />
						<Route exact path="/Onlinepaydayloans" component={Onlinepaydayloans} />
						<Route exact path="/Badcreditloans" component={Badcreditloans} />
						<Route exact path="/Financials" component={Financials} />
						<Route exact path="/Tool" component={Tool} />
						<Route exact path="/Contact" component={Contact} />
						<Route exact path="/Privacypolicy" component={Privacypolicy} />
						<Route exact path="/Questions" component={Questions} />
						<Route exact path="/Career" component={Career} />
						<PrivateRoute path="/Logout" component={Logout} />
						<PrivateRoute path="/Payday" component={Payday} />	
						<PrivateRoute path="/Paybank" component={Paybank} />
						<PrivateRoute path="/Reloan" component={Reloan} />
						<PrivateRoute path="/Setting" component={Setting} />
						<PrivateRoute path="/Application" component={Application} />	
						<PrivateRoute path="/EmpOut" component={EmpOut} />
						<PrivateRoute path="/Management" component={Management} />
						<PrivateRoute path="/Report" component={Report} />	
						<PrivateRoute path="/Search" component={Search} />	
						<PrivateRoute path="/MSetting" component={MSetting} />
					</Switch>
				</div>
			</Router>		
		</AuthContext.Provider>
	)
}

export default App;

